import { Dispatch } from 'react';
import { baseDevicesUrl } from './devices.constants';
import { DevicesActionType } from './devices.enum';
import { IState } from '../..';
import { IApiService } from '../../services/api-service';
import { IAction } from '../root/i-action';
import { ICreateNewEntityResponse } from '../facility/dto/create-entity.dto';
import { IDeviceCreate, IDevice } from './i-devices';
import { CreateDeviceDTO } from './dto/create-device.dto';
import createHistoryUtil from '../../../utils/create-history';

export interface IDevicesActions {
  getDevicesList: () => Promise<void>;
  createDevice: (data: IDeviceCreate) => Promise<void>;
  editDevice: (data :IDevice) => Promise<void>;
  deleteDevice: (id:number, goBack:boolean) => Promise<void>;
}

export class DevicesActions implements IDevicesActions {
  private readonly state: IState;

  private readonly apiService: IApiService;

  protected readonly dispatch: Dispatch<IAction>;

  public constructor(
    state: IState,
    apiService: IApiService,
    dispatch: Dispatch<IAction>,
  ) {
    this.state = state;
    this.apiService = apiService;
    this.dispatch = dispatch;
  }

  getDevicesList = async (): Promise<void> => {
    try {
      this.dispatch({
        type: DevicesActionType.GET_DEVICES_LIST_REQUEST,
        payload: null,
      });
      const payload = await this.apiService.get({
        url: 'user-manager/api/apikeys',
      });
      this.dispatch({
        type: DevicesActionType.GET_DEVICES_LIST_SUCCESS,
        payload,
      });
    } catch (err) {
      this.dispatch({ type: DevicesActionType.GET_DEVICES_LIST_FAIL, payload: err });
    }
  };

  createDevice = async (data: IDeviceCreate): Promise<void> => {
    try {
      this.dispatch({ type: DevicesActionType.CREATE_DEVICE_REQUEST, payload: data });
      const payload = await this.apiService.post<CreateDeviceDTO, ICreateNewEntityResponse>({
        url: `${baseDevicesUrl}/apikeys`,
        data: {
          ...data,
          createdTime: Date.now(),
        },
      });
      this.dispatch({ type: DevicesActionType.CREATE_DEVICE_SUCCESS, payload });
      createHistoryUtil.goBack();
    } catch (err) {
      this.dispatch({ type: DevicesActionType.CREATE_DEVICE_FAIL, payload: err });
    }
  };

  editDevice = async (data :IDevice):Promise<void> => {
    try {
      this.dispatch({ type: DevicesActionType.EDIT_DEVICE_REQUEST, payload: data });
      const payload = await this.apiService.put<CreateDeviceDTO, null>({
        url: `${baseDevicesUrl}/apikey/${data.id}`,
        data,
      });
      this.dispatch({ type: DevicesActionType.EDIT_DEVICE_SUCCESS, payload });
      createHistoryUtil.goBack();
    } catch (err) {
      this.dispatch({ type: DevicesActionType.EDIT_DEVICE_FAIL, payload: err });
    }
  };

  deleteDevice = async (id:number, goBack:boolean):Promise<void> => {
    try {
      this.dispatch({ type: DevicesActionType.DELETE_DEVICE_REQUEST, payload: null });
      const payload = await this.apiService.delete<null>({
        url: `${baseDevicesUrl}/apikey/${id}`,
      });
      this.dispatch({ type: DevicesActionType.DELETE_DEVICE_SUCCESS, payload });
      if (goBack) {
        createHistoryUtil.goBack();
      } else {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    } catch (err) {
      this.dispatch({ type: DevicesActionType.DELETE_DEVICE_FAIL, payload: err });
    }
  };
}
